import React, { Component } from 'react';
import CustomModal from './index';
import {
  ColorButton,
  ValueText,
  SwitchContainer,
  DropFile,
  AddCostTypeModal,
  EmptyStateContainer
} from '../../../../index';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Help from '../../../../../assets/images/module/general/Help.svg';
import calendar from '../../../../../assets/images/module/general/CalendarIcon.svg';
import { connect } from 'react-redux';
import RangeDatePicker from './DateRangePicker';
import Autoload from '../../../../Autoload';
import moment from 'moment';
import GlobalServices from '../../../../helpers/services/GlobalServices';
import GeneralDataHandler from '../../../../helpers/DataHandler/General';

import { showNotification, hideNotification } from '@mantine/notifications';
import RedTick from '../../../../../assets/images/module/general/RedTick.svg';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import AddIcon from '../../../../../assets/images/module/general/AddIcon.svg';
import Logo from '../../../../../assets/images/module/general/Logo.svg';
import Messenger from '../../../../../assets/images/module/general/Messenger.svg';
import MessagesIcon from '../../../../../assets/images/module/general/MessagesIcon.svg';
import DeleteIcon from '@material-ui/icons/Delete';

// Get receipts endpoint from new config
import { config } from '../../../../config/Setting';
import { Check, ThreeDRotationSharp } from "@material-ui/icons";
import { Alert, Group, Stack, Text } from "@mantine/core";
import * as customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs';
import CopyIcon from '../../../SVGs/copyIcon';
import TemplateServices from '../../../../helpers/services/TemplateServices';
import MessageTemplates from '../MessageTemplates/MessageTemplates';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
var { checkProperty, yearDifference, yearDifferenceMoment } = Autoload.MainHelper;
dayjs.extend(customParseFormat)

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

class MessageTemplatesModal extends Component {
  state = {
  };
  
  constructor(props) {
    super(props);
  }

  getTemplateTypeText(type){
    switch(type){
        case 'RentalPayment':
            return 'Mahnung wegen Zahlungsverzug Miete';
        case 'Tenant':
            return 'Mieter';
        case 'General':
            return 'Extern';
        case 'BillingStatement':
            return 'Betriebskostenabrechnung';
        default:
            return '';
    }
  }
  
  render() {
    const { open, toggle, className, selectedMessageType, history, selectedTenantId} = this.props;
    return (
      <>
        <CustomModal
          heading={"Vorlage wählen oder neue Nachricht erstellen"}
          headingClassName='select-template-heading'
          open={open}
          toggle={() => toggle()}
          className={`${className}`}
        >
            <MessageTemplates selectedMessageType={selectedMessageType} toggle={()=> toggle()} history={history} selectedTenantId={selectedTenantId}/>
        </CustomModal>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property,
    messageTemplates: state.generalReducer.messageTemplates,
  };
};

export default connect(mapStateToProps)(MessageTemplatesModal);